export class RpcHealthCheckResolver {
    constructor(providers) {
        this.providers = providers || [];
    }
    getProviderForNetwork(network) {
        return this.providers.find(p => p.supportsNetwork(network));
    }
}
